enum ItemStatus {
  UNATTEMPTED,
  PARTIALLY_ATTEMPTED,
  FULLY_ATTEMPTED,
}

export default ItemStatus;
